// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning {
  color: #d33939;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/cart/components/cart-status/cart-status.component.scss"],"names":[],"mappings":"AAIA;EACE,cAAA;AAHF","sourcesContent":[".msgs-box {\n  //padding: 10px;\n}\n\n.warning {\n  color: #d33939;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
